import LoginLayout from "../../../features/auth/layout/LoginLayout";
import { ResetUserPasswordFormPresenter } from "../../../features/user/components/ResetPawsswordUserForm/ResetPawsswordUserForm";

export default function ResetUserPasswordPage() {
    return (
        <>
                <LoginLayout>
                <ResetUserPasswordFormPresenter />
              </LoginLayout>
        </>
    )
}